<script setup lang="ts">
import { getClasses } from '~/js/composables/classes'

import ButtonPrimary from '~/vue/_teammasters/atoms/buttons/ButtonPrimary.vue'
import TextH2 from '~/vue/_teammasters/atoms/texts/TextH2.vue'
import TextProse from '~/vue/_teammasters/atoms/texts/TextProse.vue'

interface Props {
    heading: string|null
    message: string|null
    button: string|null
    utilities?: string
}

withDefaults(defineProps<Props>(), {
    utilities: ''
})

const emit = defineEmits(['action'])

const classes = {
    wrapper: {
        display: 'flex items-center justify-center p-4',
    },
    container: {
        color: 'bg-white',
        alignment: 'text-center',
        space: 'space-y-8',
        size: 'w-full',
    }
}

</script>
<template>
    <div
        role="alertdialog"
        aria-labelby="alert-tile"
        aria-describedby="alert-message"
        :class="[getClasses(classes, 'wrapper'), utilities]"
    >
        <div :class="getClasses(classes, 'container')">
            <!-- Title -->
            <h2 id="alert-title" class="text-lg font-bold">
                <TextH2>
                    {{ heading }}
                </TextH2>
            </h2>

            <!-- Message -->
            <div id="alert-message" class="prose mx-auto">
                <TextProse>
                    <span v-html="message" />
                </TextProse>
            </div>

            <!-- Confirm and Cancel Buttons -->
            <div class="inline-flex justify-between mx-auto">
                <ButtonPrimary
                    @click="emit('action')"
                    :content="button"
                    theme="dark"
                />
            </div>
        </div>
    </div>

</template>